import styled from 'styled-components'
import AppButton from 'Components/AppButton'

import {
  GREY_BACKGROUND, PRIMARY_DARK_COLOR,
} from '@CSSVars/colors'


export const _DiscoverAreaCta = styled(AppButton)`
  width: 100%;
  padding: 0 16px;
  margin: 16px 0;
  background-color: ${GREY_BACKGROUND};
  border: none;
  border-radius: 10px;
  height: 46px;
  font-size: 12px;
  line-height: 22px;
  font-weight: 600;
  color: ${PRIMARY_DARK_COLOR};
  text-align: left;
  position: relative;
  cursor: pointer;

  && {
    svg {
      position: absolute;
      right: 5px;
      top: 50%;
      transform: translateY(-50%) rotate(180deg);
      fill: ${PRIMARY_DARK_COLOR};
    }
  }
`
